import { createContext, useContext } from "react"

const ModalContext = createContext()

const useModalContext = () => {
  const context = useContext(ModalContext)

  if (!context) {
    throw new Error("You need a ModalProvider component to expose ModalContext")
  }

  return context
}

export { ModalContext, useModalContext }
